import { ReactNode } from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import { useTranslation } from 'next-i18next'

import Text from '../../components/Text'
import { COLORS } from '../../utils/colorUtils'
import { media } from '../../utils/stringUtils'
import { BREAKPOINT } from '../app/constants'
import Layout from '../layout/Layout'
import Spacer from '../../components/Spacer'

import LeftCoverPage from './LeftCoverPage'

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row-reverse;
`

const Left = styled.div`
  flex-grow: 1;
  flex-basis: 50%;
  display: none;
  background-color: ${COLORS.secondary};

  ${media(BREAKPOINT.large)} {
    display: block;
  }
`

const Right = styled.div`
  flex-grow: 1;
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
`

const RightCentered = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const StyledText = styled(Text)`
  max-width: 323px;
  font-size: 1.4rem;
  line-height: 1.1428571429em;
  color: ${COLORS.regentGray};

  & a {
    font-weight: 500;
    text-decoration: underline;
    color: ${COLORS.electricViolet};
  }
`

type AuthLayoutProps = {
  showFooter?: boolean
  title: string
  children: ReactNode
}

function AuthLayout({ showFooter = true, title, children }: AuthLayoutProps) {
  const { t } = useTranslation('auth')

  return (
    <Layout showNavbar={false} showFooter={false} title={title}>
      <Container>
        <Right>
          {showFooter && <Spacer maxHeight="100px" />}
          <RightCentered>{children}</RightCentered>
          {showFooter && (
            <>
              <Spacer maxHeight="100px" minHeight="20px" />
              <StyledText align="center">
                {t('yourPersonalDetails')}{' '}
                <Link href="/terms-and-conditions">
                  <a target="_blank">{t('terms')}</a>
                </Link>
              </StyledText>
              <Spacer maxHeight="38px" />
            </>
          )}
        </Right>
        <Left>
          <LeftCoverPage />
        </Left>
      </Container>
    </Layout>
  )
}

export default AuthLayout
